<template>
    <div>
        <div :class="['page verify',{ off: !pageOn }]">
            <VHeader type="back" @back="back" />
            <div class="page-content">
                <transition name="ontop">
                    <div v-if="pendingMessage">
                        <Pending :state="verifyState" :message="pendingMessage" @exit="exitPending" />
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { mapMutations } from 'vuex'
import { pageOn } from '@/utils/pageOn.js'
import Pending from '@/components/Pending.vue'
import WebSoc from '@/utils/WebSoc.js'
import Alert from '@/utils/Alert.js'

export default {
    components: {
        VHeader,
        Pending
    },
    name: 'auth',
    mixins: [ pageOn ],
    computed: {
        id () { return this.$store.state.id }
    },
    data () {
        return {
            pendingMessage: '',
            verifyState: false,
        }
    },
    mounted () {
        this.pendingMessage = 'Verifying Account';
        setTimeout(() => {
            
            var verify = this.$route.query.id;
            WebSoc.SEND({ t: 'verify', data: { verify }},resp => {
                if ( resp.error ) return Alert.message(resp.error);
                if ( resp.verify ) {
                    this.pendingMessage = 'Verified Successfully';
                    this.verifyState = true;
                } 
            })

        },500);
    },
    methods: {
        back () {
            this.pageOn = false;
            if ( this.verifyState ) this.$emit('success');
        },
        exitPending () {
           this.back();
        }
    }
}
</script>

<style lang="scss">
.page.auth {
    .page-content {
        > * { float: left; width: 100%; }
        > p.btn { width: calc(100% - 40px); margin-top: 50px; }
        > label:nth-child(1) { margin-top: 100px; }
        input { font-size: 30px; }
    }
}
</style>